import React from "react";
import { LogoMark } from "../../Assets/logo";

export const Footer = () => (
  <footer className="pt-12 pb-4 px-20 bg-brand-blue">
    <div className="grid md:grid-cols-4 grid-rows-1 gap-2">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <LogoMark width={44} height={44} />
          <p className="text-2xl text-white font-helvetica">ImmoInterest</p>
        </div>
        <p className="text-white font-light font-helvetica">
          Eventstil GmbH<br/>
          Max-Eyth Straße 60<br/>
          72622 Nürtingen
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <p className="text-white text-lg font-normal font-helvetica">
          Rechtliches
        </p>
        <p className="text-white text-base font-light font-helvetica">
          <a href="/impressum.pdf">Impressum</a>
        </p>
        <p className="text-white text-base font-light font-helvetica">
        <a href="/datenschutz.pdf">Datenschutzerklärung</a>
        </p>
      </div>
      
    </div>
    <div className="mt-8">
      <div className="w-full h-[1px] bg-[#dee0e04d]" />
      <p className="text-white font-helvetica font-light mt-4">
        Ⓒ 2025 immointerest | All rights reserved | Design
      </p>
    </div>
  </footer>
);
